import { SmartClassifierState } from "./types";

const state: SmartClassifierState = {
  intents: [],
  fallback: "",
  isFetching: false,
};

export default state;
